(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bookbank-cart"] && !Shopify.designMode) return;
  try {
    
function initBookBankCart(root){
 const form=root.querySelector('form');if(!form||form.dataset.ready)return;form.dataset.ready='true';
 let busy=false;
 form.addEventListener('submit',async event=>{
  if(!form.querySelector('[data-product-id="8147487981651"]'))return;event.preventDefault();if(busy)return;busy=true;
  const checkout=event.submitter&&event.submitter.name==='checkout',controls=Array.from(form.querySelectorAll('[data-cart-quantity]'));
  const updates=controls.map(input=>Math.max(0,Math.floor(Number(input.value)||0)));
  const count=controls.reduce((sum,input,i)=>sum+(input.dataset.productId==='8147487981651'?updates[i]:0),0);
  const discount=count>=5?'BOOKBANK5PACK':count>=3?'BOOKBANK3PACK':'';
  const error=root.querySelector('[data-cart-error]');error.hidden=true;
  form.querySelectorAll('button').forEach(button=>button.disabled=true);
  try{
   const response=await fetch(root.dataset.cartRoot+'/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates,discount})});
   const cart=await response.json();if(!response.ok)throw new Error(cart.description||root.dataset.updateError);
   if(checkout)location.assign(root.dataset.cartRoot.replace(/cart$/,'checkout'));else location.reload();
  }catch(e){error.textContent=e.message||root.dataset.updateError;error.hidden=false;form.querySelectorAll('button').forEach(button=>button.disabled=false);busy=false;}
 });
}
document.querySelectorAll('[data-bb-cart]').forEach(initBookBankCart);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bb-cart]').forEach(initBookBankCart));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bookbank-home"] && !Shopify.designMode) return;
  try {
    
function bookBankHome(root){if(root.dataset.ready)return;root.dataset.ready='true';const goals=JSON.parse(root.querySelector('[data-goals]').textContent);root.querySelectorAll('[data-goal]').forEach(b=>b.addEventListener('click',()=>{const g=goals[b.dataset.goal],img=root.querySelector('[data-goal-image]');img.src=g.image;img.alt=g.caption+' Example savings goal, not included.';root.querySelector('[data-goal-caption]').textContent=g.caption;root.querySelectorAll('[data-goal]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));}));root.querySelector('[data-progress]').addEventListener('input',e=>{root.querySelector('[data-fill]').style.width=e.target.value+'%';root.querySelector('[data-progress-label]').textContent='$'+e.target.value+' of $100';});}
document.querySelectorAll('.bbhome').forEach(bookBankHome);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.bbhome').forEach(bookBankHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bookbank-product"] && !Shopify.designMode) return;
  try {
    
function initBookBank(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const data=JSON.parse(root.querySelector('[data-variants]').textContent),select=root.querySelector('[data-variant]'),image=root.querySelector('[data-main-image]');
  const stickySelect=root.querySelector('[data-sticky-select]'),stickyQuantity=root.querySelector('[data-sticky-quantity]');
  stickySelect.addEventListener('change',()=>{select.value=stickySelect.value;select.dispatchEvent(new Event('change',{bubbles:true}));});
  stickyQuantity.addEventListener('change',()=>{const qty=root.querySelector('[data-quantity]');qty.value=Math.max(Number(qty.min)||1,Number(stickyQuantity.value)||1);qty.dispatchEvent(new Event('input',{bubbles:true}));});
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:data.currency}).format(value/100);
  const syncOffer=()=>{
    const qty=root.querySelector('[data-quantity]'),v=data.variants.find(x=>String(x.id)===select.value);
    if(!v)return;
    const min=Number(qty.min)||1,step=Number(qty.step)||1,max=Number(qty.max)||Infinity;
    let count=Math.max(min,Math.min(max,Math.floor(Number(qty.value)||min)));
    count=min+Math.floor((count-min)/step)*step;qty.value=count;
    stickyQuantity.value=count;stickyQuantity.min=min;stickyQuantity.step=step;
    if(Number.isFinite(max))stickyQuantity.max=max;else stickyQuantity.removeAttribute('max');
    root.querySelectorAll('[data-bundle-qty]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.bundleQty)===count)));
    const eligible=data.currency==='USD'&&v.price===3995&&(count===2||count===3);
    const total=eligible?(count===2?5000:6000):v.price*count;
    root.querySelector('[data-price]').textContent=money(total);
    const compare=root.querySelector('[data-compare]');compare.hidden=!eligible;compare.textContent=eligible?money(v.price*count):'';
    root.querySelector('[data-price-caption]').textContent=eligible?count+' books total · '+money(total/count)+' each · with WELCOME15':count+' '+(count===1?'book':'books')+' · before '+(count===1?'welcome savings':'discounts');
    root.querySelector('[data-offer-selection]').textContent=eligible?'Selected: '+count+' books for '+money(total)+' with WELCOME15 · free US shipping':'Eligible discounts are applied at checkout.';
  };
  const requested=Number(new URL(location.href).searchParams.get('bookbank_qty'));
  if(requested===2||requested===3)root.querySelector('[data-quantity]').value=requested;
  syncOffer();
  root.querySelectorAll('[data-bundle-qty]').forEach(b=>b.addEventListener('click',()=>{root.querySelector('[data-quantity]').value=b.dataset.bundleQty;syncOffer();}));
  root.querySelector('[data-quantity]').addEventListener('input',syncOffer);

  const showImage=(src,alt)=>{if(image){image.src=src;image.alt=alt||'';}root.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.image===src)));};
  root.querySelectorAll('[data-image]').forEach(b=>b.addEventListener('click',()=>showImage(b.dataset.image,b.dataset.alt)));
  root.querySelectorAll('[data-pick]').forEach(b=>b.addEventListener('click',()=>{select.value=b.dataset.pick;select.dispatchEvent(new Event('change',{bubbles:true}));}));
  select.addEventListener('change',()=>{
    const v=data.variants.find(x=>String(x.id)===select.value);if(!v)return;stickySelect.value=select.value;
    root.querySelector('[data-price]').textContent=money(v.price);
    const compare=root.querySelector('[data-compare]');compare.hidden=!(v.compare_at_price>v.price);compare.textContent=v.compare_at_price?money(v.compare_at_price):'';
    root.querySelectorAll('[data-buy]').forEach(b=>{b.disabled=!v.available;b.textContent=v.available?'Add to cart / Buy now':'Sold out';});
    root.querySelectorAll('[data-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pick===select.value)));
    root.querySelector('[data-sticky-variant]').textContent=v.title;
    const quantity=root.querySelector('[data-quantity]'),rule=v.quantity_rule||{min:1,increment:1};quantity.min=rule.min||1;quantity.step=rule.increment||1;if(rule.max)quantity.max=rule.max;else quantity.removeAttribute('max');quantity.value=Math.max(rule.min||1,Math.min(rule.max||Infinity,Number(quantity.value)||1));syncOffer();
    if(data.colorImages[v.id])showImage(data.colorImages[v.id],v.title+' '+root.querySelector('h1').textContent);
    const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
  });
}
document.querySelectorAll('[data-bookbank]').forEach(initBookBank);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bookbank]').forEach(initBookBank));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bookbank-reference"] && !Shopify.designMode) return;
  try {
    
function initBookBank(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const data=JSON.parse(root.querySelector('[data-variants]').textContent),select=root.querySelector('[data-variant]'),image=root.querySelector('[data-main-image]');
  data.colorImages["46319217901651"]="https://cdn.shopify.com/s/files/1/0737/7662/7795/files/bookbank-pink-bear-cream-background.png?v=1789559955";
  const stickySelect=root.querySelector('[data-sticky-select]'),stickyQuantity=root.querySelector('[data-sticky-quantity]');
  stickySelect.addEventListener('change',()=>{select.value=stickySelect.value;select.dispatchEvent(new Event('change',{bubbles:true}));});
  stickyQuantity.addEventListener('change',()=>{const qty=root.querySelector('[data-quantity]');qty.value=Math.max(Number(qty.min)||1,Number(stickyQuantity.value)||1);qty.dispatchEvent(new Event('input',{bubbles:true}));});
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:data.currency}).format(value/100);
  let checkoutPending=false;
  window.addEventListener('pageshow',()=>{
    if(!root.isConnected)return;
    checkoutPending=false;
    const variant=data.variants.find(v=>String(v.id)===select.value);
    root.querySelectorAll('[data-buy]').forEach(button=>{button.disabled=!variant?.available;if(!variant?.available)button.textContent='Sold out';});
    syncOffer();
  });
  const beginCheckout=()=>{
    if(checkoutPending)return;
    const notice=root.querySelector('[data-preview-status]');
    const fail=message=>{notice.textContent=message;notice.hidden=false;notice.scrollIntoView({block:'center',behavior:'smooth'});};
    if(root.dataset.checkoutEnabled!=='true'){fail('Checkout is awaiting launch activation. Your colour choices are saved on this page.');return;}
    const count=Number(root.querySelector('[data-quantity]').value);
    if(![1,3,5].includes(count)){fail('Please choose an offer.');return;}
    const ids=bundleColourChoices[count];
    if(!ids||ids.length!==count||ids.some(id=>!/^\d+$/.test(id)||!data.variants.some(v=>String(v.id)===id&&v.available))){fail('Please choose an available colour for every book.');return;}
    const code=count===3?root.dataset.discountThree:count===5?root.dataset.discountFive:'';
    if(count>1&&!code){fail('This bundle is not available for checkout yet.');return;}
    const quantities=new Map();ids.forEach(id=>quantities.set(id,(quantities.get(id)||0)+1));
    const target=new URL(root.dataset.cartUrl+'/'+Array.from(quantities,([id,n])=>id+':'+n).join(','),location.origin);
    target.searchParams.set('discount',code);
    checkoutPending=true;root.querySelectorAll('[data-buy]').forEach(button=>{button.disabled=true;button.textContent='Opening secure checkout…';});
    location.assign(target.href);
  };
  root.querySelectorAll('[data-buy]').forEach(button=>button.addEventListener('click',beginCheckout));
  root.querySelector('form').addEventListener('submit',event=>{event.preventDefault();beginCheckout();});
  const mix=root.querySelector('[data-mix]'),mixRows=root.querySelector('[data-mix-rows]'),mixSummary=root.querySelector('[data-mix-summary]');
  const availableColours=data.variants.filter(v=>v.available).map(v=>String(v.id));
  const mixedDefaults=count=>Array.from({length:count},(_,i)=>availableColours[i%availableColours.length]||select.value);
  const bundleColourChoices={1:[select.value],3:mixedDefaults(3),5:mixedDefaults(5)};
  let colourChoices=bundleColourChoices[1];
  let displayedCount=0;
  const updateMixSummary=count=>{
    const totals=new Map();colourChoices.slice(0,count).forEach(id=>{const v=data.variants.find(x=>String(x.id)===id);if(v)totals.set(v.title,(totals.get(v.title)||0)+1);});
    mixSummary.textContent=Array.from(totals,([name,n])=>n+' × '+name).join(' · ');
    root.dataset.bundleColours=JSON.stringify(colourChoices.slice(0,count));
  };
  const renderMix=count=>{
    mix.hidden=false;root.setAttribute('data-mixed-bundle','');mix.dataset.count=String(count);colourChoices=bundleColourChoices[count];
    mix.querySelector('legend').textContent=count===1?'Choose your colour':count===3?'Choose 3 colours · 1 book free':'Choose 5 colours · 2 books free';
    if(displayedCount===count){updateMixSummary(count);return;}
    displayedCount=count;mixRows.replaceChildren();
    for(let i=0;i<count;i++){
      const row=document.createElement('div');row.className='bbr-mix-row';
      const dot=document.createElement('span');dot.className='bbr-colour-dot';dot.setAttribute('aria-hidden','true');const paint=()=>{const name=picker.selectedOptions[0].textContent.toLowerCase();dot.style.background=name.includes('black')?'#302b29':name.includes('brown')?'#a37542':name.includes('pink')?'#eaa38e':'#e5d8bd';};
      const label=document.createElement('label');label.htmlFor=root.id+'-colour-'+i;label.textContent='Book '+(i+1);
      if(i>=(count===3?2:3)){const gift=document.createElement('small');gift.textContent='FREE';label.append(gift);}
      const picker=document.createElement('select');picker.id=label.htmlFor;picker.dataset.bookColour=String(i);
      data.variants.forEach(v=>{const option=document.createElement('option');option.value=String(v.id);option.textContent=v.title+(v.available?'':' — Sold out');option.disabled=!v.available;picker.append(option);});
      if(!data.variants.some(v=>String(v.id)===colourChoices[i]&&v.available))colourChoices[i]=String(data.variants.find(v=>v.available).id);
      picker.value=colourChoices[i];paint();
      picker.addEventListener('change',()=>{colourChoices[i]=picker.value;if(count===1){select.value=picker.value;select.dispatchEvent(new Event('change',{bubbles:true}));}paint();updateMixSummary(count);showImage(data.colorImages[picker.value],picker.selectedOptions[0].textContent+' BookBank savings book');});
      const choice=document.createElement('div');choice.className='bbr-colour-control';choice.append(dot,picker);row.append(label,choice);mixRows.append(row);
    }
    updateMixSummary(count);
  };
  const syncOffer=()=>{
    const qty=root.querySelector('[data-quantity]'),v=data.variants.find(x=>String(x.id)===select.value);
    if(!v)return;
    let count=Number(qty.value);if(![1,3,5].includes(count))count=1;qty.value=count;stickyQuantity.value=count;renderMix(count);
    root.querySelectorAll('[data-bundle-qty]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.bundleQty)===count)));
    const active=true;
    const original=count===3?11999:count===5?19999:7990,total=active?(count===3?7999:count===5?9999:3995):3995*count,saved=original-total;
    const usd=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n/100);
    root.querySelector('[data-price]').textContent=usd(total);root.querySelectorAll('[data-buy]').forEach(b=>{if(v.available)b.textContent=usd(total)+' '+root.dataset.ctaLabel;});
    const compare=root.querySelector('[data-compare]');compare.hidden=!saved;compare.textContent=usd(original);
    root.querySelector('[data-price-caption]').textContent=count+' '+(count===1?'book':'books')+' · '+(active?root.dataset.discountedLabel:root.dataset.normalLabel);
    const savings=root.querySelector('[data-savings]');savings.hidden=!saved;savings.textContent=root.dataset.saveLabel+' '+usd(saved)+' ('+Math.round(saved/original*100)+'%)';
    root.querySelector('[data-offer-selection]').textContent=count===1?'1 book · $39.95':count+' books · '+usd(total)+' total · '+root.dataset.saveLabel+' '+usd(saved);
  };
  const requested=Number(new URL(location.href).searchParams.get('bookbank_qty'));
  if(requested===3||requested===5)root.querySelector('[data-quantity]').value=requested;
  syncOffer();
  root.querySelectorAll('[data-bundle-qty]').forEach(b=>b.addEventListener('click',()=>{root.querySelector('[data-quantity]').value=b.dataset.bundleQty;syncOffer();const first=data.variants.find(v=>String(v.id)===colourChoices[0]);if(first)showImage(data.colorImages[first.id],first.title+' BookBank savings book');}));
  root.querySelector('[data-quantity]').addEventListener('input',syncOffer);root.querySelector('[data-quantity]').addEventListener('change',syncOffer);

  const showImage=(src,alt)=>{if(image){image.src=src;image.alt=alt||'';}root.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.image===src)));};
  root.querySelectorAll('[data-image]').forEach(b=>b.addEventListener('click',()=>showImage(b.dataset.image,b.dataset.alt)));
  if(image){
    image.style.touchAction='pan-y';image.draggable=false;
    let swipeStart=null;
    image.addEventListener('pointerdown',e=>{if(e.isPrimary){swipeStart={x:e.clientX,y:e.clientY,id:e.pointerId};image.setPointerCapture(e.pointerId);}});
    image.addEventListener('pointercancel',()=>{swipeStart=null;});
    image.addEventListener('pointerup',e=>{
      if(!swipeStart||e.pointerId!==swipeStart.id)return;
      const dx=e.clientX-swipeStart.x,dy=e.clientY-swipeStart.y;swipeStart=null;
      if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.3)return;
      const photos=Array.from(root.querySelectorAll('[data-image]'));if(photos.length<2)return;
      const current=Math.max(0,photos.findIndex(b=>b.getAttribute('aria-pressed')==='true'));
      const next=photos[(current+(dx<0?1:-1)+photos.length)%photos.length];showImage(next.dataset.image,next.dataset.alt);
    });
  }

  root.querySelectorAll('[data-pick]').forEach(b=>b.addEventListener('click',()=>{select.value=b.dataset.pick;select.dispatchEvent(new Event('change',{bubbles:true}));}));
  select.addEventListener('change',()=>{
    const v=data.variants.find(x=>String(x.id)===select.value);if(!v)return;stickySelect.value=select.value;
    root.querySelector('[data-price]').textContent=money(v.price);
    const compare=root.querySelector('[data-compare]');compare.hidden=!(v.compare_at_price>v.price);compare.textContent=v.compare_at_price?money(v.compare_at_price):'';
    root.querySelectorAll('[data-buy]').forEach(b=>{b.disabled=!v.available;b.textContent=v.available?'Add to cart':'Sold out';});
    root.querySelectorAll('[data-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pick===select.value)));
    root.querySelector('[data-sticky-variant]').textContent=v.title;
    const quantity=root.querySelector('[data-quantity]'),rule=v.quantity_rule||{min:1,increment:1};quantity.min=rule.min||1;quantity.step=rule.increment||1;if(rule.max)quantity.max=rule.max;else quantity.removeAttribute('max');quantity.value=Math.max(rule.min||1,Math.min(rule.max||Infinity,Number(quantity.value)||1));syncOffer();
    if(data.colorImages[v.id])showImage(data.colorImages[v.id],v.title+' '+root.querySelector('h1').textContent);
    const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
  });
}
document.querySelectorAll('[data-bookbank]').forEach(initBookBank);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bookbank]').forEach(initBookBank));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
